// material
import {
  Card,
  Table,
  Stack,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  Box,
  CircularProgress,
  Button,
  TextField,
  Autocomplete,
  LinearProgress,
} from '@mui/material';
import { isEmpty, omitBy } from 'lodash';
import SearchIcon from '@mui/icons-material/Search';
import { useMemo, useState } from 'react';

// components
import NumberDiscoveryRangeDialog from '../components/Dialogs/NumberDiscoveryRange';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { UserListHead } from '../sections/@dashboard/user';
import { Search, SearchIconWrapper, StyledInputBase } from '../components/SearchInput';

// store
import { api as stockApi, hooks as stockHooks } from '../store/domains/stock';

const TABLE_HEAD = [
  { id: 'prefix', label: 'prefix', alignRight: false },
  { id: 'msisdn', label: 'msisdn', alignRight: false },
  { id: 'partnerId', label: 'Partner', alignRight: true },
  { id: '' },
];

export default function NumberDiscovery() {
  const {
    handleChangeRowsPerPage,
    handleClick,
    handleCloseRangeDialog,
    handleOpenRangeDialog,
    resetSelectedList,
    rowsPerPage,
    selected,
    openRangeDialog,
  } = stockHooks.useStock();

  const [searchValue, setSearchValue] = useState('');
  const [numberValue, setNumberValue] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [partnerValue, setPartnerValue] = useState('');

  const params = useMemo(
    () => omitBy({ size: rowsPerPage, prefix: searchValue, number: numberValue }, (v) => v.toString().length < 1),
    [rowsPerPage, searchValue, numberValue]
  );
  const {
    data: numberDiscovery,
    isLoading: numberDiscoveryLoading,
    isFetching,
  } = stockApi.useGetNumberDiscovery(params);
  const { data: posManagerOrganizations, isLoading: posManagerOrganizationsLoading } =
    stockApi.useGetOrganizations(null);
  const [postNumberDIscovery, { isLoading: postNumberDiscoveryLoading }] = stockApi.usePostNumberDiscovery();
  const handleChange = (value) => {
    setPartnerValue(value.label);
    postNumberDIscovery({ partnerId: value.id, identifiers: selected })
      .unwrap()
      .then(() => {
        resetSelectedList();
      });
  };

  const handleChangeSearchInput = (event) => {
    setSearchValue(event.target.value);
  };
  const handleChangeNumberInput = (event) => {
    setNumberValue(event.target.value);
  };

  if (numberDiscoveryLoading || posManagerOrganizationsLoading) {
    return <CircularProgress />;
  }
  return (
    <Page title="User">
      <NumberDiscoveryRangeDialog
        open={openRangeDialog}
        handleClose={handleCloseRangeDialog}
        posManagerOrganizations={posManagerOrganizations}
      />
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Stack spacing={3} sx={{ my: 2 }}>
            <Box display="flex" spacing={3} sx={{ my: 2 }}>
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  onChange={handleChangeSearchInput}
                  value={searchValue}
                  placeholder="Prefix"
                  inputProps={{ 'aria-label': 'search' }}
                />
              </Search>{' '}
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  onChange={handleChangeNumberInput}
                  value={numberValue}
                  placeholder="Number"
                  inputProps={{ 'aria-label': 'search' }}
                />
              </Search>
            </Box>
          </Stack>
          <Box display="flex" spacing={3} sx={{ my: 2 }}>
            <Autocomplete
              value={partnerValue}
              onChange={(_, newValue) => {
                handleChange(newValue);
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              options={posManagerOrganizations || []}
              sx={{ width: 300 }}
              renderInput={(params) => <TextField {...params} label="Select Partner" />}
              disabled={isEmpty(selected)}
            />
            <FormControl
              sx={{
                mx: 2,
                width: 130,
              }}
            >
              <InputLabel>Rows per page:</InputLabel>
              <Select value={rowsPerPage} label="Rows per page:" onChange={handleChangeRowsPerPage}>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Button onClick={handleOpenRangeDialog} variant="contained">
              Assign to dealer
            </Button>
          </Box>
        </Stack>

        <Card>
          {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}
          {(postNumberDiscoveryLoading || isFetching) && <LinearProgress />}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  headLabel={TABLE_HEAD}
                  rowCount={numberDiscovery?.data?.length}
                  numSelected={selected.length}
                  // onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {numberDiscovery?.data?.map((row) => {
                    const { prefix, msisdn, partnerId, id } = row;
                    // const partnerName = posManagerOrganizations?.find((item) => +item?.id === +partnerId);
                    const isItemSelected = selected.indexOf(id) !== -1;

                    return (
                      <TableRow
                        hover
                        key={msisdn}
                        tabIndex={-1}
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, id)} />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {prefix}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">{msisdn}</TableCell>
                        {/* <TableCell align="left">{role}</TableCell>
                        <TableCell align="left">{isVerified ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="left">
                          <Label variant="ghost" color={(status === 'banned' && 'error') || 'success'}>
                            {sentenceCase(status)}
                          </Label>
                        </TableCell> */}

                        <TableCell align="right">{partnerId}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {/* {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )} */}
              </Table>
            </TableContainer>
          </Scrollbar>

          {/* <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            // count={get(numberDiscovery, 'data.length', 0) * 2}
            rowsPerPage={rowsPerPage}
            page={page}
            // onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            
          /> */}
        </Card>
      </Container>
    </Page>
  );
}
